import React from "react";
import {useSelector, RootStateOrAny, useDispatch} from "react-redux"
import { useTranslation } from "react-i18next";
import {
  ChoiceGroup,
  IChoiceGroupOption,
  IChoiceGroupStyles,
} from "office-ui-fabric-react";
import { clearAlerts } from "../../../../../config/redux/alerts/alertsActions";

const choiceGroupS: IChoiceGroupStyles = {
  root: {
    marginBottom: 25,
  },
};

interface RegistrationChoiceGroupProps {
  setActiveForm: (option?: string) => void;
}

const RegistrationChoiceGroup: React.FC<RegistrationChoiceGroupProps> = ({
  setActiveForm,
}) => {
  const dispatch = useDispatch()
  const { t } = useTranslation("admin");
  const { error } = useSelector(
    (state: RootStateOrAny) => state.register
  );

  const options: IChoiceGroupOption[] = [
    { key: "USER", text: t("auth.radioButtons.registerExistingDepartment") as string },
    { key: "DEPARTMENT", text: t("auth.radioButtons.registerDepartmentAndUser") as string },
  ];

  const setOption = (
    ev?: React.FormEvent<any>,
    option?: IChoiceGroupOption
  ): void => {
    if(error){
      dispatch(clearAlerts())
    }

    //elvis dosent work for some reason
    if(option){
      setActiveForm(option.key);
    }
  };

  return (
    <ChoiceGroup
      options={options}
      styles={choiceGroupS}
      onChange={setOption}
      label={""}
      required={true}
    />
  );
};

export default RegistrationChoiceGroup;